import { inject } from '@angular/core';
import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { from, switchMap } from 'rxjs';
import { hasAuthentication } from './auth.context';
import { AuthRepository } from './auth.repository';
import { acquireIdToken } from './msal';

const HEADER_AUTHORIZATION_NAME = 'Authorization';
const TOKEN_PREFIX = 'Bearer';

export const authInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const isJsonResponseOrBlob = req.responseType === 'json' || req.responseType === 'blob';
  if (!hasAuthentication(req) || !isJsonResponseOrBlob) {
    return next(req);
  }

  const withBearer = (token?: string) => {
    if (!token) {
      return next(req);
    }
    const headers = req.headers.set(HEADER_AUTHORIZATION_NAME, `${TOKEN_PREFIX} ${token}`);
    return next(req.clone({ headers }));
  };

  // Dev/test password session uses a stored local token; otherwise get a fresh
  // Entra ID token from MSAL (renewed silently and cached).
  const devToken = inject(AuthRepository).$devToken();
  if (devToken) {
    return withBearer(devToken);
  }

  return from(acquireIdToken()).pipe(switchMap(withBearer));
};
